/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { Button } from 'reactstrap';
import { SurveyActionData } from '@g17eco/types/surveyAction';
import { useHistory, useLocation } from 'react-router-dom';
import UniversalTrackerClassInterface from '../../../model/UniversalTrackerClassInterface';

interface BreadcrumbsProps {
  utr?: UniversalTrackerClassInterface;
  survey: SurveyActionData;
  selectedAltCode: string;
  rootBreadcrumb: {
    label: string;
    url: string;
  };
}

export const QuestionContainerHeaderBreadcrumbs = (props: BreadcrumbsProps) => {
  const { utr, selectedAltCode, rootBreadcrumb } = props;

  const history = useHistory();
  const location = useLocation();

  if (!utr) {
    return null;
  }

  const goToOverview = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('standard'); // Don't carry the standard around
    history.push({
      pathname: rootBreadcrumb.url,
      search: searchParams.toString(),
    });
  };

  const standardCode = utr.getTypeCode(selectedAltCode);
  const standardName = utr.getTypeName(selectedAltCode);

  return (
    <div className='question-container-breadcrumbs w-100 d-flex ml-2 text-ThemeTextPlaceholder'>
      <Button
        className='p-0'
        color='link'
        onClick={goToOverview}
        data-testid='survey-overview-breadcrumb-item'
        style={{ minWidth: 'fit-content' }}
      >
        {rootBreadcrumb.label}
      </Button>
      <div className='mx-2'>&#47;</div>
      <div className='text-truncate flex-grow-1'>{`${standardName} ${utr && standardCode ? '- ' + standardCode : ''} `}</div>
    </div>
  );
};
